import { Grid,  SwipeableDrawer, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import "../../style/navbar/navbar.css"

const NavBarMovil = ({ logo, state, toggleDrawer, list }) => (
    
  <>
    <section className="navbar-movil-superior">
      <Grid container>
        <Grid item xs={6} sx={{
          display:'flex',
          alignItems:'center',
          justifyContent:'flex-start'
        }}>
          <div className="contenedorimagenlogo">
            <Link to='/' >
              <img
                src={logo}
                alt="axinntus"
                
                title="axinntus"
                className="logomobilAxinntus"
              />
            </Link>
          </div>
        </Grid>
        <Grid item xs={6} className="menu">
          <label className="burger" htmlFor="burger">
            <input
              type="checkbox"
              id="burger"
              checked={state.right}
              onChange={toggleDrawer("right", !state.right)}
            />
            <span></span>
            <span></span>
            <span></span>
          </label>
          <SwipeableDrawer
    className="listado-menu"
    anchor="right"
    open={state.right}
    onClose={toggleDrawer("right", false)}
    onOpen={toggleDrawer("right", true)}
   PaperProps={{
    sx: { 
        width: {
            xs: "90%",   // móviles muy pequeños
            sm: "400px",    // móviles normales
            md: "400px",   // tablets
            lg: "500px",   // escritorio
        }
    }
  }}
>
  <Box sx={{width:'100%', display:'flex', alignItems:'center', justifyContent:'center', mt:7, mb:-5}}>
    <Box
        sx={{

            width: '250px',
            padding: "20px ",       
            background: "#fff",

        }}
    >
        <img
            src={logo}
            alt="logo"
            style={{ width: "100%", height: "auto" }}
        />
    </Box>
</Box>
    {list("right")}
</SwipeableDrawer>

        </Grid>
      </Grid>
    </section>
   
  </>
);

export default NavBarMovil;